/**
 * One line of weather for Hoy (Section 7). The WMO weather codes Open-Meteo
 * returns are folded into a few words a crew member can act on.
 */

export type Sky = { es: string; en: string; wet: boolean };

export function skyFromCode(code: number): Sky {
  if (code === 0) return { es: 'despejado', en: 'clear', wet: false };
  if (code <= 2) return { es: 'poco nublado', en: 'partly cloudy', wet: false };
  if (code === 3) return { es: 'nublado', en: 'overcast', wet: false };
  if (code === 45 || code === 48) return { es: 'con neblina', en: 'foggy', wet: false };
  if (code >= 95) return { es: 'con tormenta', en: 'stormy', wet: true };
  if ((code >= 51 && code <= 67) || (code >= 80 && code <= 82)) return { es: 'con lluvia', en: 'rainy', wet: true };
  return { es: 'nublado', en: 'cloudy', wet: false };
}

export type WeatherNow = { tempC: number; code: number; windKph: number; at: string };

export function weatherLine(w: WeatherNow, lang: 'es' | 'en'): string {
  const sky = skyFromCode(w.code);
  const temp = Math.round(w.tempC);
  const wind = Math.round(w.windKph);
  return lang === 'es'
    ? `${sky.es}, ${temp} grados, viento ${wind} km/h`
    : `${sky.en}, ${temp} C, wind ${wind} km/h`;
}
